import { Injectable, inject } from "@angular/core";
import { ApiClientService } from "~app/common/services/api-client.service";
import { Atgardstyper } from "../models/virkeskopAtgardstyper";

@Injectable({
    providedIn: "root"
})
export class AtgardService {
    private readonly api = inject(ApiClientService);

    isForyngringsavverkning = (atgardstyp: string) => Atgardstyper.foryngringsavverkningstyper.some(x => x === atgardstyp);

    isForyngringsavverkningOrVagLednAtgardstyp = (atgardstyp: string) => this.isForyngringsavverkning(atgardstyp) ||
        atgardstyp === Atgardstyper.VagLedning;

    isMarkberedningForyngringRecommended = (atgardstyp: string) => [
        Atgardstyper.UtglesningFS,
        Atgardstyper.VagLedning,
        Atgardstyper.VindSkada,
        Atgardstyper.NSFrihuggning,
        Atgardstyper.NSUtglesning,
        Atgardstyper.NSLuckhuggning,
        Atgardstyper.NSRestavv
    ].some(x => x === atgardstyp);

    requiresAvverkningsanmalanAndMaxDistanceForEdit = (atgardstyp: string): boolean =>
        Atgardstyper.foryngringsavverkningstyper.concat([Atgardstyper.VagLedning]).some(x => x === atgardstyp);

    requiresAvverkningsanmalanAndMaxDistance = (atgardstyp: string): boolean => Atgardstyper.foryngringsavverkningstyper.concat([
        Atgardstyper.VagLedning,
        Atgardstyper.VindSkada,
        Atgardstyper.NSFrihuggning,
        Atgardstyper.NSUtglesning,
        Atgardstyper.NSLuckhuggning,
        Atgardstyper.NSRestavv
    ]).some(x => x === atgardstyp);
}
